import { reduce } from 'lodash';

export const deserializeDefaultValues = (response) => {
  const initialValue = {};
  return reduce(
    response,
    (obj, item) => {
      return {
        ...obj,
        [item.type]: item.value,
      };
    },
    initialValue,
  );
};

export const serializeDefaultValues = (values = {}) => {
  const result = [];
  for (const [key, value] of Object.entries(values)) {
    if (!!value) result.push({ type: key, value: value });
  }
  return result;
};



// WEBPACK FOOTER //
// src/actions/defaultValues/serializers.js